import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SearchBar from '../components/SearchBar/SearchBar';
import ShowCase from '../components/ShowCase/ShowCase';
import Supporting from '../components/Footer/Supporting';
import TopInformation from '../components/Header/TopInformation';
import AppRelease from '../components/Header/AppRelease';

import { login, showPasswordReset } from '../actions/piano';
import { getOffers, searchOffers, getPurchasedOffers, setIsStreaming, donePageLoading } from '../actions/offer';
import { getPremiumDistributors } from '../actions/distributor';
import { useLocation } from 'react-router-dom';
import { encodeKeyword } from '../common/methods/CommonUtil';
import Const from '../common/variables/Const';
import queryString from 'query-string';

import "./DebugLog.js"

function Index(props) {
	const selectedDistributorId = process.env.REACT_APP_DISTRIBUTORS_NAME;
	
	const [isLoading, setLoading] = useState(true);
	const [sortType, setSortType] = useState('');
	const [keyword, setKeyword] = useState('');
	const location = useLocation();
	const [isQueryCheck, setIsQueryCheck] = useState(false);
	const [isRedirect, setIsRedirect] = useState(false);
	//const [selectedDistributorId, SetSelectedDistributorId] = useState(null);
	
	const [premiumDistributors, SetPremiumDistributors] = useState(null);
	const [smallLogoUrl, setSmallLogoUrl] = useState('');
	const [mainDispLogoUrl, setMainDispLogoUrl] = useState('');
	// お知らせ表示
	const [isInformation, setIsInformation] = useState(false);
	const [isInformationCalled, setIsInformationCalled] = useState(false);
	
	//プルダウンお知らせ
	const isAppInfoVisibility = (process.env.REACT_APP_APP_RELEASE_INFORMATION_VISIVILITY === "true") ? true : false ;
	const isInfoVisibility = (process.env.REACT_APP_INFORMATION_VISIVILITY === "true") ? true : false ;
	const isSponserVisibility = (process.env.REACT_APP_SPONSER_VISIVILITY === "true") ? true : false ;
	const isMainLogoVisibility = (process.env.REACT_APP_MAIN_LOGO_VISIVILITY === "true") ? true : false ;
	
	
	useEffect(() => {
		// クエリパラメーター取得
		//const queryString = require('query-string');
		let parsed = queryString.parse(props.location.search);
		if(Object.keys(parsed).length === 0) window.location.href = '/?sortType=date';

		if (parsed.distributor_id) {
			//SetSelectedDistributorId(parsed.distributor_id);
		}

		// 検索クエリの場合
		if (!isQueryCheck && parsed.q !== '') {
			setKeyword(parsed.q);
			parsed.sortType = 'search';

			// 稀にsetKeywordでセットされない場合がある@リトライで治る
			if (keyword === '') {
				setIsQueryCheck(false);
			} else {
				setIsQueryCheck(true);
			}
			handleSearch(false);
			return;
		}
		if (parsed.sortType === 'date') {
			setSortType('date');
			return;
		}
		if (parsed.sortType === 'purchased') {
			setSortType('purchased');
			return;
		}
	});
	useEffect(() => {
		// クエリパラメーターにqがある場合は必ずsearchに切り替えさせる
		let parsed = queryString.parse(props.location.search);
		if (parsed.q !== '' && sortType !== 'search' && parsed.q !== undefined && props.offers !== null) {
			setSortType('search');
		}
	}, [sortType]);

	useEffect(() => {
		// クエリパラメーター取得
		let query = queryString.parse(props.location.search);
		if (query !== undefined) {
			props.showPasswordReset(query, gotoTopPage);
		}
	});
	const gotoTopPage = () => {
		window.location.href = '/';
	};

	useEffect(() => {
		getOfferList(selectedDistributorId);
		/*
		if (selectedDistributorId) {
			getOfferList(selectedDistributorId);
		}
		*/
	}, [props.loggedIn, sortType]);

	const getOfferList = distributorId => {
		props.donePageLoading(false);
		if (sortType === 'date') {
			props.getOffers(props.loggedIn, distributorId);
		}
		props.setIsStreaming(false);
		if (location.state) {
			setSortType(location.state.sortType);
		}
		if (sortType === 'purchased') props.getPurchasedOffers(props.loggedIn, distributorId);
		if (sortType === 'purchased' && !props.loggedIn) {
			props.login();
		}
		setLoading(false);
	}

	useEffect(() => {
		// 配信事業者IDをローカルステートに保持
		setSmallLogoUrl('/assets/img/common/logo-watermark.png');
		if(isMainLogoVisibility) {
			setMainDispLogoUrl('/assets/img/common/banner-large.jpg');
		}
		/*
		if (props.customize) {
			props.getPremiumDistributors();
			// 配信事業者IDをローカルステートに保持
			//SetSelectedDistributorId(props.customize.distributor_id);
			setSmallLogoUrl('/assets/img/common/logo-watermark.png');
			if(isMainLogoVisibility) {
				setMainDispLogoUrl('/assets/img/common/banner-large.jpg');
			}
			getOfferList(props.customize.distributor_id);
		}
		*/
	}, [props.customize])


	useEffect(() => {
		if (props.premiumDistributors !== null) {
			SetPremiumDistributors(props.premiumDistributors);
		}
	}, [props.premiumDistributors])

	// エラーハンドリング
	useEffect(() => {
		if (props.error !== null && props.error !== undefined) {
			// ネットワークエラー
			if (props.error.toString() === 'Error: Network Error') {
				console.log('ネットワークエラー');
			}
			// ステータスコードが帰ってきた場合
			if (props.error.response !== undefined) {
				if (props.error.response.status >= 500) {
					window.location.href = '/500';
				}
				if (props.error.response.status === 404) {
					window.location.href = '/404';
				}
			}
		}
		// props.err
		if (props.err !== null && props.err !== undefined) {
			// ネットワークエラー
			if (props.err.toString() === 'Error: Network Error') {
				console.log('ネットワークエラー');
			}
			// ステータスコードが帰ってきた場合
			if (props.err.response !== undefined) {
				if (props.err.response.status >= 500) {
					window.location.href = '/500';
				}
				if (props.err.response.status === 404) {
					window.location.href = '/404';
				}
			}
		}
	}, [props.error, props.err]);

	// Get JSON file(お知らせ)
	useEffect(() => {
		if(!isInformationCalled) {
			setIsInformationCalled(true);
			const url = process.env.REACT_APP_API_DIR_URL + `v1/static/information`;
			fetch(url)
			.then(response => {
				if (!response.ok || response.status !== 200) {
					throw new Error(response.statusText);
				}
				return response.json()
			})
			.then(data => {
				if (data.length <= 0) {
					setIsInformation(false);
					return;
				}
				window.topics = data;
				setIsInformation(true);
			})
			.catch(error => {
				console.log(error);
				setIsInformation(false);
			});
		}
	}, [isInformationCalled]);

	const handleSearch = isEnter => {
		if (keyword === '' || keyword === undefined) {
			return;
		}
		setSortType('search');
		if (isEnter) {
			setIsRedirect(true);
			return;
		}
		props.searchOffers(keyword, props.loggedIn, selectedDistributorId);
	};

	const handleSortType = functionSortType => {
		if (functionSortType === 'purchased') {
			if (!props.loggedIn) {
				props.login();
				return;
			}
		}
		setSortType(functionSortType);
	};
	const redirectScript = (keyword) => {
		window.location.href = Const.hrefSearch + encodeKeyword(keyword);
	};

	function redirectSearch(keyword, selectedDistributorId) {
		redirectScript(keyword);
	}

	if (isLoading) {
		return (
			<div>
				<style jsx="true">{'\
        .global-footer{\
          display:none;\
        }\
      '}</style>
			</div>
		);
	}
	return (
		<div>
			{isMainLogoVisibility ? <section className="large-banner-frame"> <img className="large-banner" src={mainDispLogoUrl} alt=""/></section> : ''}
			{isInfoVisibility && isInformation ? <TopInformation language={props.language} topics={window.topics}/> : ''}
			{isAppInfoVisibility ? <AppRelease language={props.language} /> : ''}
				<section className="home">
					<div className="home__inner">
					{isRedirect ? redirectSearch(keyword, selectedDistributorId) : ''}
					<SearchBar sortType={sortType} keyword={keyword} handleSortType={handleSortType} setKeyword={setKeyword} onEnterPressed={handleSearch} language={props.language} selectedDistributorId={selectedDistributorId} distributors={premiumDistributors}/>
					<section className='contents-tags'>
						{props.isFetching ? '' : 
							<ShowCase 
								offers={props.offers} 
								sortType={sortType} 
								keyword={keyword} 
								language={props.language} 
								donePageLoading={props.donePageLoading} 
								selectedDistributorId={selectedDistributorId}
								smallLogoUrl={smallLogoUrl}
							/>}
					</section>
				</div>
				</section>
				{isSponserVisibility == true && <Supporting sortType={sortType} />}
		</div>
	);
}

const mapStateToProps = state => {
	return {
		isFetching: state.offer.isFetching,
		offers: state.offer.offers,
		language: state.piano.language,
		loggedIn: state.piano.loggedIn,
		error: state.offer.error,
		err: state.offer.err,
		customize: state.customize.customize,
		premiumDistributors: state.distributors.premiumDistributors
	};
};

const mapDispatchToProps = dispatch => ({
	login: () => dispatch(login()),
	getOffers: (isLoggedIn, distributorId) => dispatch(getOffers(isLoggedIn, distributorId)),
	searchOffers: (keyword, isLoggedIn, distributorId) => dispatch(searchOffers(keyword, isLoggedIn, distributorId)),
	getPurchasedOffers: (isLoggedIn, distributorId) => dispatch(getPurchasedOffers(isLoggedIn, distributorId)),
	showPasswordReset: (query, gotoTopPage) => dispatch(showPasswordReset(query, gotoTopPage)),
	setIsStreaming: state => dispatch(setIsStreaming(state)),
	donePageLoading: state => dispatch(donePageLoading(state)),
	getPremiumDistributors: async() => await dispatch(getPremiumDistributors())
});

export default connect(mapStateToProps, mapDispatchToProps)(Index);
